export const LOCALITIES_LOAD = 'LOCALITIES_LOAD';
export const LOCALITIES_LOAD_SUCCESS = 'LOCALITIES_LOAD_SUCCESS';
export const LOCALITIES_LOAD_FAIL = 'LOCALITIES_LOAD_FAIL';
export const LOCATIONS_SAVE = 'LOCATIONS_SAVE';
export const PROVINCE_SAVE = 'PROVINCE_SAVE';
